import type React from "react";
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import Navigation from "../Navigation/Navigation";
import ThemeToggle from "../../common/ThemeToggle/ThemeToggle";
import { Separator } from "../../ui/separator";

const Header: React.FC = () => {
	const [isFullScreenNavOpen, setIsFullScreenNavOpen] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const getSignupButtonText = () => {
		if (location.pathname.startsWith("/mokumoku")) {
			return "もくもく会に参加する";
		}
		if (location.pathname.startsWith("/study-groups")) {
			return "勉強会に参加する";
		}
		if (location.pathname.startsWith("/hackathons")) {
			return "ハッカソンに参加する";
		}
		return "学習ギルドに参加する";
	};

	const toggleFullScreenNav = () => {
		setIsFullScreenNavOpen(!isFullScreenNavOpen);
	};

	return (
		<header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
			<div className="container max-w-7xl">
				<div className="flex h-16 items-center justify-between">
					<div className="flex items-center">
						<Link
							to="/"
							className="flex items-center text-primary-600 hover:text-primary-700 transition-colors"
						>
							<img
								src="/images/mokumoku-logo.png"
								alt="大船渡もくもく会"
								className="h-10 w-auto"
							/>
							<span className="ml-2 text-primary text-xl font-semibold">
								LeGu Ofunato
							</span>
						</Link>
					</div>

					{/* デスクトップナビゲーション */}
					<nav className="hidden lg:flex items-center space-x-4">
						<Navigation />
						<Separator orientation="vertical" className="h-6" />
						<ThemeToggle />
						<Button variant="secondary" onClick={() => navigate("/login")}>
							ログイン
						</Button>
						<Button onClick={() => navigate("/signup")}>
							{getSignupButtonText()}
						</Button>
					</nav>

					{/* モバイルメニューボタン */}
					<div className="flex items-center gap-2 lg:hidden">
						<ThemeToggle />
						<Button variant="ghost" size="icon" onClick={toggleFullScreenNav}>
							<span className="sr-only">メニューを開く</span>
							<Menu className="h-5 w-5" />
						</Button>
					</div>
				</div>
			</div>

			{/* モバイルフルスクリーンナビゲーション */}
			{isFullScreenNavOpen && (
				<div className="fixed inset-0 z-50 bg-background">
					<div className="container h-full py-6">
						<nav className="flex flex-col space-y-4">
							<Navigation />
							<Separator />
							<div className="flex flex-col space-y-2">
								<Button variant="secondary" onClick={() => navigate("/login")}>
									ログイン
								</Button>
								<Button onClick={() => navigate("/signup")}>
									{getSignupButtonText()}
								</Button>
							</div>
						</nav>
					</div>
				</div>
			)}
		</header>
	);
};

export default Header;
